export default "__VITE_ASSET__BU$CN8vf__"